import { shapeDate } from '@avangard/utils/data';

import {
    BaseEntity,
    Entity as DecribeEntity,
    Relation,
    RelationList,
} from '@avangard/utils/entity';

import { SchoolEntity } from '@modules/schools/entities';
import { SocialsEntity } from './socials.entity';
import { StudentParentEntityList } from './student-parent.entity-list';
import { StudentMedicalEntity } from './student-medical.entity';
import { StudentIndividualEntity } from './student-individual.entity';

import type { Student } from '@modules/types/graphql';
import type { StudentParentEntity } from './student-parent.entity';

export type Entity = Partial<Omit<Student, 'school' | 'attachedUser'>> | null;

@DecribeEntity('StudentEntity')
class StudentEntity extends BaseEntity {
    id: string;
    fullName: string;
    fullNameGenitive: string;
    passportSerial: string;
    passportNumber: string;
    passportIssued: string;
    passportAddress: string;
    address: string;
    birthdate: Date | null;
    phone: string;
    email: string;
    olCourseCertificateUrl: string;

    @Relation(() => SchoolEntity)
    school: SchoolEntity;

    @Relation(() => SocialsEntity)
    socials: SocialsEntity;

    @RelationList(() => StudentParentEntityList)
    parents: StudentParentEntity[];

    @Relation(() => StudentMedicalEntity)
    medical: StudentMedicalEntity;

    @Relation(() => StudentIndividualEntity)
    individual: StudentIndividualEntity;

    constructor(student: Entity) {
        super(student);

        this.id = student?.id ?? '';
        this.fullName = student?.fullName ?? '';
        this.fullNameGenitive = student?.fullNameGenitive ?? '';
        this.passportSerial = student?.passportSerial ?? '';
        this.passportNumber = student?.passportNumber ?? '';
        this.passportIssued = student?.passportIssued ?? '';
        this.passportAddress = student?.passportAddress ?? '';
        this.address = student?.address ?? '';
        this.phone = student?.phone ?? '';
        this.email = student?.email ?? '';

        this.olCourseCertificateUrl = student?.olCourseCertificateUrl ?? '';

        this.birthdate = shapeDate(student?.birthdate);
    }
}

export { StudentEntity };
